// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wrap_Wrap__mk9Fj {
  display: flex;
  width: 100%;
  max-width: 1920px;
  padding: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Wrap/Wrap.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AACJ","sourcesContent":[".Wrap {\n    display: flex;\n    width: 100%;\n    max-width: 1920px;\n    padding: 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrap": `Wrap_Wrap__mk9Fj`
};
export default ___CSS_LOADER_EXPORT___;
